import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.className
 * @param {React.ReactNode|function} props.children
 * @returns {JSX.Element}
 */
function DraggableSection({ id, children, className }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    // Don't block touch events on container - only on drag handle
    touchAction: "auto",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} className={className}>
      {typeof children === "function" ? children(listeners) : children}
    </div>
  );
}

export default DraggableSection;
